import NProgress from "nprogress"
import * as React from "react"
import { Spinner } from "./spinner"

interface LoadingProps {
  fullPage?: boolean
  size?: "sm" | "default" | "lg" | "xl"
}

export function Loading({ fullPage = false, size = "lg" }: LoadingProps) {
  React.useEffect(() => {
    NProgress.start()
    return () => {
      NProgress.done()
    }
  }, [])

  if (fullPage) {
    return (
      <div className="fixed inset-0 z-50 flex items-center justify-center bg-background/80 backdrop-blur-sm">
        <Spinner size={size} />
      </div>
    )
  }

  return <Spinner size={size} />
} 